import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, switchMap } from 'rxjs/operators';

import { GeneralService } from '../../../services/general/general.service';
import * as actions from './general.actions';

@Injectable()
export class GeneralEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly service: GeneralService,
  ) {}

  getGeneral$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.getGeneral),
      switchMap(({}) =>
        this.service.getGeneral().pipe(
          map((general) => {
            return actions.getGeneralSuccess({ general });
          }),
          catchError((error: any) => of(actions.getGeneralFailure(error))),
        ),
      ),
    ),
  );

  updateGeneralPersonalInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.updateGeneralPersonalInfo),
      exhaustMap((action) =>
        this.service.updateGeneralPersonalInfo(action.personalInfo).pipe(
          map(() => {
            return actions.updateGeneralPersonalInfoSuccess({
              personalInfo: action.personalInfo,
            });
          }),
          catchError((error: any) =>
            of(actions.updateGeneralPersonalInfoFailure(error)),
          ),
        ),
      ),
    ),
  );

  updateGeneralPersonalInfoSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.updateGeneralPersonalInfoSuccess),
      map(() => actions.getGeneral()),
    ),
  );

  updateGeneralCompanyInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.updateGeneralCompanyInfo),
      exhaustMap((action) =>
        this.service.updateGeneralCompanyInfo(action.companyInfo).pipe(
          map(() => {
            return actions.updateGeneralCompanyInfoSuccess({
              companyInfo: action.companyInfo,
            });
          }),
          catchError((error: any) =>
            of(actions.updateGeneralCompanyInfoFailure(error)),
          ),
        ),
      ),
    ),
  );

  updateGeneralCompanyInfoSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.updateGeneralCompanyInfoSuccess),
      map(() => actions.getGeneral()),
    ),
  );
}
